import { useGroups } from '../../../state/entities'
import useGroupSuggestions from '../../../state/queries/useGroupSuggestions'
import formikConnectedMultiItemSelect from '../../basics/ItemSelect/formikConnectedMultiItemSelect'
import multiItemSelect from '../../basics/ItemSelect/multiItemSelect'

/**********************************************************************
 * SelectGroups
 **********************************************************************/
const SelectGroups = multiItemSelect({
  multiSelect: true,
  useSuggestions: useGroupSuggestions,
  renderItemDescription: (group) => group.name,
})

export default SelectGroups

/**********************************************************************
 * SelectGroupsFormik
 **********************************************************************/
export const SelectGroupsFormik = formikConnectedMultiItemSelect({
  component: SelectGroups,
  useItems: (uuids) => useGroups(uuids).groups,
  mapItems: (groups) => groups.map(({ uuid }) => uuid),
})
